import React from 'react';

export default function Firefox({
  width = 88,
  height = 88,
}: {
  width?: number,
  height?: number,
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 88 88"
    >
      <path
        fill="url(#firefox_paint0_linear)"
        d="M79.724 29.498c-1.675-4.04-5.069-8.402-7.733-9.78 2.168 4.262 3.423 8.537 3.902 11.727 0 0 0 .022.008.064-4.358-10.89-11.75-15.282-17.786-24.843a41.104 41.104 0 01-.91-1.48 11.208 11.208 0 01-.423-.804 7.038 7.038 0 01-.576-1.523.102.102 0 00-.087-.104.137.137 0 00-.072 0 .076.076 0 00-.017.011c-.01 0-.02.011-.03.015l.017-.021c-9.684 5.684-12.97 16.2-13.271 21.462a19.268 19.268 0 00-10.618 4.097c-.318-.27-.651-.522-.997-.755a17.946 17.946 0 01-.108-9.443c-3.96 1.808-7.04 4.662-9.28 7.187h-.017c-1.53-1.94-1.422-8.34-1.335-9.676-.018-.084-1.139.583-1.283.685a28.056 28.056 0 00-3.768 3.234 33.772 33.772 0 00-3.6 4.327 32.648 32.648 0 00-5.173 11.706l-.052.256a66.01 66.01 0 00-.38 2.411v.086c-.34 1.759-.553 3.54-.635 5.33v.198C5.5 65.202 22.76 82.5 44.05 82.5c19.068 0 34.9-13.874 38-32.098.064-.494.117-.992.175-1.49.767-6.627-.085-13.591-2.501-19.414zM35.29 59.74c.18.085.35.18.534.263l.026.016c-.185-.09-.372-.183-.558-.28h-.002zm40.615-28.214v-.037.042-.005z"
      />
      <path
        fill="url(#firefox_paint1_radial)"
        d="M79.724 29.497c-1.675-4.04-5.069-8.401-7.733-9.78 2.168 4.263 3.423 8.537 3.902 11.727v.079c3.639 9.883 1.656 19.934-1.2 26.076-4.417 9.5-15.112 19.24-31.854 18.765C24.766 75.85 8.832 62.392 5.856 44.781c-.542-2.78 0-4.19.273-6.445-.332 1.738-.459 2.24-.624 5.33v.199c0 21.336 17.26 38.634 38.55 38.634 19.068 0 34.9-13.874 38-32.098.064-.493.117-.992.175-1.49.762-6.627-.09-13.591-2.506-19.414z"
      />
      <path
        fill="url(#firefox_paint2_radial)"
        d="M79.724 29.497c-1.675-4.04-5.069-8.401-7.733-9.78 2.168 4.263 3.423 8.537 3.902 11.727v.079c3.639 9.883 1.656 19.934-1.2 26.076-4.417 9.5-15.112 19.24-31.854 18.765C24.766 75.85 8.832 62.392 5.856 44.781c-.542-2.78 0-4.19.273-6.445-.332 1.738-.459 2.24-.624 5.33v.199c0 21.336 17.26 38.634 38.55 38.634 19.068 0 34.9-13.874 38-32.098.064-.493.117-.992.175-1.49.762-6.627-.09-13.591-2.506-19.414z"
      />
      <path
        fill="url(#firefox_paint3_radial)"
        d="M60.988 34.038c.085.06.16.12.241.179a20.972 20.972 0 00-3.58-4.681c-11.983-12.01-3.141-26.04-1.651-26.755l.016-.02c-9.684 5.684-12.97 16.2-13.27 21.461.448-.03.896-.069 1.353-.069 7.227 0 13.521 3.984 16.891 9.886z"
      />
      <path
        fill="url(#firefox_paint4_radial)"
        d="M44.123 36.437c-.063.965-3.451 4.276-4.636 4.276-10.963 0-12.742 6.646-12.742 6.646.481 5.598 4.373 10.207 9.081 12.646.215.11.431.21.642.31.377.16.755.322 1.132.465 1.615.57 3.306.896 5.016.964 19.214.904 22.94-23.024 9.072-29.972 3.55-.62 7.236.813 9.294 2.261-3.369-5.901-9.665-9.885-16.892-9.885-.457 0-.904.039-1.354.07A19.269 19.269 0 0032.13 28.32c.588.5 1.252 1.165 2.65 2.545 2.62 2.591 9.33 5.259 9.343 5.572z"
      />
      <path
        fill="url(#firefox_paint5_radial)"
        d="M44.123 36.437c-.063.965-3.451 4.276-4.636 4.276-10.963 0-12.742 6.646-12.742 6.646.481 5.598 4.373 10.207 9.081 12.646.215.11.431.21.642.31.377.16.755.322 1.132.465 1.615.57 3.306.896 5.016.964 19.214.904 22.94-23.024 9.072-29.972 3.55-.62 7.236.813 9.294 2.261-3.369-5.901-9.665-9.885-16.892-9.885-.457 0-.904.039-1.354.07A19.269 19.269 0 0032.13 28.32c.588.5 1.252 1.165 2.65 2.545 2.62 2.591 9.33 5.259 9.343 5.572z"
      />
      <path
        fill="url(#firefox_paint6_radial)"
        d="M30.336 27.036c.313.202.57.373.802.529a17.944 17.944 0 01-.107-9.443c-3.96 1.808-7.04 4.662-9.28 7.187.181-.005 5.773-.106 8.585 1.727z"
      />
      <path
        fill="url(#firefox_paint7_radial)"
        d="M5.856 44.782c2.976 17.612 18.91 31.07 36.996 31.584 16.742.474 27.43-9.265 31.855-18.766 2.855-6.143 4.838-16.192 1.2-26.076v-.074c0 .01 0 .023.008.064 1.366 8.95-3.175 17.62-10.275 23.483a1.215 1.215 0 00-.02.05c-13.836 11.29-27.075 6.812-29.755 4.984-.187-.09-.374-.184-.56-.28-8.067-3.858-11.4-11.23-10.685-17.546-6.81 0-9.133-5.758-9.133-5.758s6.115-4.37 14.175-.57c7.463 3.521 14.473.571 14.473.57-.014-.314-6.722-2.989-9.339-5.573-1.397-1.379-2.061-2.044-2.65-2.544-.318-.27-.651-.523-.998-.756-.229-.16-.48-.322-.802-.529-2.812-1.833-8.404-1.731-8.588-1.727h-.018c-1.528-1.94-1.42-8.34-1.334-9.676-.018-.083-1.14.584-1.284.685a28.05 28.05 0 00-3.768 3.235 33.772 33.772 0 00-3.6 4.326 32.648 32.648 0 00-5.173 11.706c-.03.075-1.402 6.076-.725 9.188z"
      />
      <path
        fill="url(#firefox_paint8_radial)"
        d="M57.65 29.535a20.974 20.974 0 013.58 4.681c.2.151.393.312.578.483 8.739 8.063 4.167 19.48 3.82 20.3 7.099-5.864 11.64-14.534 10.273-23.484-4.358-10.896-11.75-15.288-17.786-24.849a40.96 40.96 0 01-.91-1.48 11.172 11.172 0 01-.423-.804 7.038 7.038 0 01-.576-1.523.101.101 0 00-.087-.104.138.138 0 00-.072 0 .074.074 0 00-.017.011c-.01 0-.02.011-.03.015-1.491.713-10.333 14.745 1.65 26.754z"
      />
      <path
        fill="url(#firefox_paint9_radial)"
        d="M61.805 34.69a7.428 7.428 0 00-.578-.482c-.078-.06-.16-.119-.24-.178-2.058-1.447-5.745-2.881-9.294-2.262 13.865 6.948 10.142 30.876-9.072 29.972a17.115 17.115 0 01-5.016-.964 21.01 21.01 0 01-1.132-.465c-.218-.1-.435-.2-.642-.31l.026.016c2.68 1.833 15.919 6.312 29.754-4.984l.021-.05c.343-.805 4.915-12.22-3.827-20.293z"
      />
      <path
        fill="url(#firefox_paint10_radial)"
        d="M26.745 47.358s1.78-6.646 12.742-6.646c1.185 0 4.573-3.315 4.636-4.276.062-.962-7.01 2.952-14.474-.57-8.06-3.8-14.174.57-14.174.57s2.322 5.758 9.132 5.758c-.714 6.317 2.618 13.681 10.685 17.546.18.085.35.18.534.264-4.708-2.434-8.595-7.048-9.08-12.646z"
      />
      <path
        fill="url(#firefox_paint11_linear)"
        d="M79.724 29.498c-1.675-4.04-5.069-8.402-7.733-9.78 2.168 4.262 3.423 8.537 3.902 11.727 0 0 0 .022.008.064-4.358-10.89-11.75-15.282-17.786-24.843a41.104 41.104 0 01-.91-1.48 11.208 11.208 0 01-.423-.804 7.038 7.038 0 01-.576-1.523.102.102 0 00-.087-.104.137.137 0 00-.072 0 .076.076 0 00-.017.011c-.01 0-.02.011-.03.015l.017-.021c-9.684 5.684-12.97 16.2-13.271 21.462.45-.031.897-.07 1.354-.07 7.226 0 13.52 3.984 16.891 9.886-2.058-1.447-5.744-2.881-9.294-2.262 13.866 6.948 10.143 30.876-9.071 29.973a17.111 17.111 0 01-5.016-.965 20.977 20.977 0 01-1.133-.465c-.218-.1-.435-.199-.642-.31l.026.016c-.186-.09-.374-.183-.56-.28.18.086.35.18.534.264-4.717-2.439-8.604-7.053-9.09-12.65 0 0 1.779-6.646 12.741-6.646 1.186 0 4.574-3.315 4.636-4.277-.014-.313-6.723-2.988-9.339-5.572-1.397-1.379-2.061-2.045-2.65-2.545-.318-.27-.652-.522-.998-.755a17.944 17.944 0 01-.107-9.443c-3.96 1.808-7.04 4.662-9.28 7.187h-.018c-1.528-1.94-1.42-8.34-1.334-9.676-.018-.084-1.14.583-1.284.685a28.05 28.05 0 00-3.767 3.234 33.773 33.773 0 00-3.6 4.327 32.649 32.649 0 00-5.173 11.706l-.052.256c-.072.34-.4 2.066-.444 2.435 0 .03 0-.027 0 0a44.924 44.924 0 00-.576 5.392v.198C5.5 65.202 22.76 82.5 44.05 82.5c19.068 0 34.9-13.874 38-32.098.064-.494.117-.992.175-1.49.767-6.627-.085-13.591-2.501-19.414zM75.9 31.482v.041-.041z"
      />
      <defs>
        <linearGradient
          id="firefox_paint0_linear"
          x1="74.621"
          x2="10.488"
          y1="15.105"
          y2="76.845"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.05" stopColor="#FFF44F" />
          <stop offset="0.11" stopColor="#FFE847" />
          <stop offset="0.22" stopColor="#FFC830" />
          <stop offset="0.37" stopColor="#FF980E" />
          <stop offset="0.4" stopColor="#FF8B16" />
          <stop offset="0.46" stopColor="#FF672A" />
          <stop offset="0.53" stopColor="#FF3647" />
          <stop offset="0.7" stopColor="#E31587" />
        </linearGradient>
        <radialGradient
          id="firefox_paint1_radial"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(80.3678 0 0 80.5441 71.663 11.6)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.13" stopColor="#FFBD4F" />
          <stop offset="0.19" stopColor="#FFAC31" />
          <stop offset="0.25" stopColor="#FF9D17" />
          <stop offset="0.28" stopColor="#FF980E" />
          <stop offset="0.4" stopColor="#FF563B" />
          <stop offset="0.47" stopColor="#FF3750" />
          <stop offset="0.71" stopColor="#F5156C" />
          <stop offset="0.78" stopColor="#EB0878" />
          <stop offset="0.86" stopColor="#E50080" />
        </radialGradient>
        <radialGradient
          id="firefox_paint2_radial"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(80.3678 0 0 80.5441 42.297 44.528)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.3" stopColor="#960E18" />
          <stop offset="0.35" stopColor="#B11927" stopOpacity="0.74" />
          <stop offset="0.43" stopColor="#DB293D" stopOpacity="0.34" />
          <stop offset="0.5" stopColor="#F5334B" stopOpacity="0.09" />
          <stop offset="0.53" stopColor="#FF3750" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id="firefox_paint3_radial"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(58.223 0 0 58.3507 51.986 -6.676)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.13" stopColor="#FFF44F" />
          <stop offset="0.25" stopColor="#FFDC3E" />
          <stop offset="0.51" stopColor="#FF9D12" />
          <stop offset="0.53" stopColor="#FF980E" />
        </radialGradient>
        <radialGradient
          id="firefox_paint4_radial"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(38.2662 0 0 38.3501 33.409 65.569)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.35" stopColor="#3A8EE6" />
          <stop offset="0.47" stopColor="#5C79F0" />
          <stop offset="0.67" stopColor="#9059FF" />
          <stop offset="1" stopColor="#C139E6" />
        </radialGradient>
        <radialGradient
          id="firefox_paint5_radial"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(19.68019 -4.88001 5.74397 23.16437 43.451 34.957)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.21" stopColor="#9059FF" stopOpacity="0" />
          <stop offset="0.28" stopColor="#8C4FF3" stopOpacity="0.06" />
          <stop offset="0.75" stopColor="#7716A8" stopOpacity="0.45" />
          <stop offset="0.97" stopColor="#6E008B" stopOpacity="0.6" />
        </radialGradient>
        <radialGradient
          id="firefox_paint6_radial"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(27.5298 0 0 27.5902 41.281 8.307)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFE226" />
          <stop offset="0.12" stopColor="#FFDB27" />
          <stop offset="0.3" stopColor="#FFC82A" />
          <stop offset="0.5" stopColor="#FFA930" />
          <stop offset="0.73" stopColor="#FF7E37" />
          <stop offset="0.79" stopColor="#FF7139" />
        </radialGradient>
        <radialGradient
          id="firefox_paint7_radial"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(117.455 0 0 117.713 62.921 -9.193)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.11" stopColor="#FFF44F" />
          <stop offset="0.46" stopColor="#FF980E" />
          <stop offset="0.62" stopColor="#FF5634" />
          <stop offset="0.72" stopColor="#FF3647" />
          <stop offset="0.9" stopColor="#E31587" />
        </radialGradient>
        <radialGradient
          id="firefox_paint8_radial"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="rotate(84.245 23.756 30.347) scale(85.7989 56.2493)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFF44F" />
          <stop offset="0.06" stopColor="#FFE847" />
          <stop offset="0.17" stopColor="#FFC830" />
          <stop offset="0.3" stopColor="#FF980E" />
          <stop offset="0.36" stopColor="#FF8B16" />
          <stop offset="0.45" stopColor="#FF672A" />
          <stop offset="0.57" stopColor="#FF3647" />
          <stop offset="0.74" stopColor="#E31587" />
        </radialGradient>
        <radialGradient
          id="firefox_paint9_radial"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(73.3272 0 0 73.4882 40.634 18.524)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.14" stopColor="#FFF44F" />
          <stop offset="0.48" stopColor="#FF980E" />
          <stop offset="0.59" stopColor="#FF5634" />
          <stop offset="0.66" stopColor="#FF3647" />
          <stop offset="0.9" stopColor="#E31587" />
        </radialGradient>
        <radialGradient
          id="firefox_paint10_radial"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(80.2571 0 0 80.4332 59.99 22.826)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.09" stopColor="#FFF44F" />
          <stop offset="0.23" stopColor="#FFE141" />
          <stop offset="0.51" stopColor="#FFAF1E" />
          <stop offset="0.63" stopColor="#FF980E" />
        </radialGradient>
        <linearGradient
          id="firefox_paint11_linear"
          x1="73.851"
          x2="19.279"
          y1="14.774"
          y2="69.228"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.17" stopColor="#FFF44F" stopOpacity="0.8" />
          <stop offset="0.27" stopColor="#FFF44F" stopOpacity="0.63" />
          <stop offset="0.49" stopColor="#FFF44F" stopOpacity="0.22" />
          <stop offset="0.6" stopColor="#FFF44F" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
}
